module.exports = __webpack_public_path__ + "img/trash.8b47c8d5.svg";